import { useState } from 'react';
import { Buttons, ChooseLanguage } from 'components';

const ChooseLangBtn = () => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <>
      <Buttons.SecondaryNormal
        id='chooseLang'
        style={{ width: '100%' }}
        onClick={() => setIsOpen(true)}
      >
        Choose Languages
      </Buttons.SecondaryNormal>
      {isOpen && <ChooseLanguage title='Languages' close={() => setIsOpen(false)} />}
    </>
  );
};

export default ChooseLangBtn;
